// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Dividend } from './dividend';
import { Entry } from './entry';
import { Shareholder } from './shareholder';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShareholderDividend extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  shareholderDividendId!: number;
  admittedTotal!: number;
  centsInDollar!: number;
  createdBy!: string;
  createdDate!: Date;
  datePaid!: Date;
  dividendId!: number;
  entryId?: number;
  paidInCash!: number;
  paidInSpecie!: number;
  shareholderId!: number;
  totalUnclaimed!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  dividend!: Dividend;
  entry!: Entry;
  shareholder!: Shareholder;
}

